<template>
  <div class="to-do-card-list">
    <div v-if="title" class="list-title">
      {{ $t(title) }}
      <WsTextChip001
        v-if="error"
        :text-label="$t('至少填寫一項待辦事項')"
        leading-icon="icon-warning"
        red
        thin
        icon-xl
        font-size-sm
      />
    </div>
    <TodoCardSort
      v-if="sortEdit && list && list.length > 0"
      :list="list"
      @sorting-complete="$_sortingComplete($event)"
      @sorting-active="$_sortingActive($event)"
      @click-batch="$_onOpenPopup('batchPopup')"
      @add-sub-task-from-task="$emit('add-sub-task-from-task')"
    />
    <div v-if="!sorting">
      <div class="list-content">
        <slot />
      </div>
      <div v-if="button" class="to-do-card-list_button">
        <slot name="buttons" />
      </div>
    </div>
    <PopUp
      bottom
      title="批次編輯"
      :clickOutsideClose="false"
      :popUpActive="isActive.batchPopup"
      @click="$_onClosePopup('batchPopup')"
    >
      <ToDoCardEdit
        v-if="isActive.batchPopup"
        :value="batchSubTask"
        :hideFields="batchHideFields"
        :uploadModule="uploadModule"
        :links="batchSubTask.links"
        :propsMenuItems="propsMenuItems"
        @go-to="$_onGoToFile($event)"
        @input="$_onInput($event)"
        @add-related-module="$_onAddRelatedModule"
        @delete-related-module="$_onDeleteRelatedModule($event)"
        @input-related-module="$_onInputRelatedModule($event)"
        @paste-related-module="$_onPasteRelatedModule($event)"
      />
      <template slot="bottomBtn">
        <WsTextChip001
          red
          thin
          iconLg
          fontSizeXs
          textLabel="注意，將會把現有待辦資料覆蓋"
          leadingIcon="icon-warning"
        />
        <WsButton001 outLine @click="$_onClosePopup('batchPopup')">
          {{ $t('取消') }}
        </WsButton001>
        <WsButton001 @click="$_onSubmit">
          {{ $t('確定') }}
        </WsButton001>
      </template>
    </PopUp>
  </div>
</template>
<script>
import H_file from '@/helpers/file';
import H_common from '@/helpers/common';

export default {
  name: 'ToDoCardList',
  props: {
    title: {
      type: String,
    },
    error: {
      type: Boolean,
      default: false,
    },
    button: {
      type: Boolean,
      default: false,
    },
    sortEdit: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    uploadModule: {
      type: String,
    },
    batchHideFields: {
      type: Array,
      default: () => ['checkIcon', 'deleteIcon', 'taker'],
    },
    propsMenuItems: {
      type: Array,
    },
  },
  data() {
    return {
      isActive: {
        batchPopup: false,
      },
      sorting: false,
      batchSubTask: {
        done_at: null,
        start_at: '',
        expired_at: '',
        name: '',
        remark: '',
        taker: null,
        takerValue: null,
        attaches: [],
        images: [],
        errors: [],
        links: [],
        multiSystemClasses: [],
      },
    };
  },
  methods: {
    $_sortingComplete($event) {
      this.$emit('sorting-complete', $event);
    },
    $_sortingActive($event) {
      this.sorting = $event;
      this.$emit('sorting-active', $event);
    },
    $_onOpenPopup(type) {
      this.isActive[type] = true;
    },
    $_onClosePopup(type) {
      if (!this.isActive[type]) return;
      this.isActive[type] = false;
      const actionList = {
        batchPopup: () => {
          this.batchSubTask = {
            done_at: null,
            start_at: '',
            expired_at: '',
            name: '',
            remark: '',
            taker: null,
            takerValue: null,
            attaches: [],
            images: [],
            errors: [],
            links: [],
            multiSystemClasses: [],
          };
        },
      };
      if (actionList[type]) actionList[type]();
    },
    $_onGoToFile($event) {
      H_file.goToFile($event);
    },
    $_onInput($event) {
      this.batchSubTask = $event;
    },
    $_onSubmit() {
      const { attaches, expired_at, name, remark, links, taker, takerValue, multiSystemClasses } =
        this.batchSubTask;
      this.$emit('submit-batch', {
        attaches,
        expired_at,
        name,
        remark,
        links,
        taker,
        takerValue,
        multiSystemClasses,
      });
      this.$_onClosePopup('batchPopup');
    },
    $_onAddRelatedModule() {
      const baseData = {
        type: 'domain',
        name: '',
        url: '',
        from_module: '',
        module_page_value: '',
        remark: '',
      };
      this.$set(this.batchSubTask, 'links', [...this.batchSubTask.links, baseData]);
    },
    $_onDeleteRelatedModule(index) {
      this.batchSubTask.links.splice(index, 1);
    },
    $_onInputRelatedModule($event) {
      const { value, key, index } = $event;
      this.$set(this.batchSubTask.links[index], key, value);
    },
    async $_onPasteRelatedModule(index) {
      try {
        const jsonData = await H_common.pasteText();
        const data = JSON.parse(jsonData);
        if (!data.url) {
          H_common.pasteFail();
          return;
        }
        const linkData = {
          ...this.batchSubTask.links[index],
          ...data,
          type: 'domain',
        };
        this.$set(this.batchSubTask.links, index, linkData);
      } catch (error) {
        H_common.pasteFail();
      }
    },
  },
};
</script>
<style lang="scss">
.to-do-card-list {
  @include auto_margin_top(40px);
  .list-title {
    @include flex_align;
    justify-content: space-between;
    font-size: 1.125rem;
    font-weight: bold;
    line-height: 1.33;
    color: var(--gray-900);
  }
  .list-content {
    @include auto_margin_top(20px);
    .to-do-card-edit {
      @include auto_margin_top(20px);
    }
    .to-do-card {
      @include auto_margin_top(20px);
    }
  }
  .to-do-card-list_button {
    @include flex_align;
    @include auto_margin_top(10px);
  }
}
</style>
